var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFolder = function SvgFolder(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7.2C3 6.08 3 5.52 3.218 5.092C3.40974 4.71569 3.71569 4.40974 4.092 4.218C4.52 4 5.08 4 6.2 4H8.6C9.48 4 9.92 4 10.324 4.115C10.6818 4.21717 11.0176 4.38502 11.314 4.61C11.648 4.864 11.912 5.216 12.44 5.92L14 8H3V7.2Z",
    fill: "currentColor",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 9.4C3 8.56 3 8.14 3.163 7.819C3.30685 7.53651 3.53651 7.30685 3.819 7.163C4.139 7 4.559 7 5.4 7H18.6C19.44 7 19.86 7 20.181 7.163C20.4631 7.30702 20.6924 7.53666 20.836 7.819C21 8.139 21 8.559 21 9.4V17.6C21 18.44 21 18.86 20.837 19.181C20.693 19.4631 20.4633 19.6924 20.181 19.836C19.861 20 19.441 20 18.6 20H5.4C4.56 20 4.14 20 3.819 19.836C3.53666 19.6924 3.30702 19.4631 3.163 19.181C3 18.861 3 18.441 3 17.6V9.4Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFolder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "folder.333fe6649b5d7d41bbac802404cd7b44.svg";